import script from "./InternetConfigOptions.vue?vue&type=script&setup=true&lang=ts"
export * from "./InternetConfigOptions.vue?vue&type=script&setup=true&lang=ts"

import "./InternetConfigOptions.vue?vue&type=style&index=0&id=653ad3aa&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-653ad3aa"]])

export default __exports__